import {NgModule, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Routes, RouterModule,PreloadAllModules} from '@angular/router';

import {DashboardRoutingModule} from './dashboard-routing.module';
import {DashboardComponent} from '../dashboard/components/dashboard.component';
import {LeadComponent} from '../leads/components/lead.component';
import {RoleGuardService} from '../../role-guard.service';

const routes: Routes = [
    {
        path: 'dashboard', children: [
            {path: '', component: DashboardComponent,canActivate :[RoleGuardService]},

        ]
    },
];

@NgModule({
    imports: [
        CommonModule,
        DashboardRoutingModule,
        RouterModule.forRoot(routes,
          {
            useHash: false,
            preloadingStrategy: PreloadAllModules
          })
    ],
    exports: [RouterModule],
    declarations: [DashboardComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DashboardModule {}



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/dashboard.module.ts